module.exports = __webpack_public_path__ + "img/img_commodity01_Shopping.1ea6c46b.png";